import logo from './logo.svg';
import './App.css';
import JobList from './components/JobList';
import JobForm from './components/JobForm';
import React from 'react';

function App() {
  return (
    <div className="App">
      <h1>Red Tuna</h1>
      <JobList />
    </div>
  );
}

export default App;
